import { defineNuxtPlugin } from 'nuxt/app';
import colors from '~~/common/assets/styles/variables/colors.module.scss';
import awUserInterface from '~~/common/assets/styles/variables/aw-user-interface.module.scss';
import grids from '~~/common/assets/styles/variables/grids.module.scss';

const styleVariables = {
  ...colors,
  ...awUserInterface,
  ...grids,
};
export default defineNuxtPlugin((nuxtApp) => {
  const styleVariablesProxy = new Proxy(
    styleVariables,
    {
      get (obj, key) {
        const value = typeof key === 'string' ? obj[key] : undefined;
        if (value === undefined) {
          const logger = nuxtApp.$logger as undefined | { error: (msg: string) => void };
          (logger || console).error(`Style variable ${String(key)} not found.`);
        }
        return value;
      },
    },
  );
  nuxtApp.provide('styleVariables', styleVariablesProxy);
});

// https://nuxt.com/docs/guide/directory-structure/plugins#typing-plugins
declare module '#app' {
  interface NuxtApp extends StyleVariablesPlugin {}
}

declare module 'vue' {
  interface ComponentCustomProperties extends StyleVariablesPlugin {}
}

interface StyleVariablesPlugin {
  // TODO find a way to actually process scss files into a type. That would
  // be cool to have autocomplete in templates for $styleVariables...
  $styleVariables: typeof styleVariables;
}
